module.exports = __webpack_public_path__ + "img/file_edit_compute.20e689b8.png";